/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessfulActionResponse as DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse } from '../../models/Digiwork/MaitreD/Api/Configuration/Model/CustomResponses/successful-action-response';

export interface FreeTable$Params {
  tableId: string;
  venueId?: string;
}

export function freeTable(http: HttpClient, rootUrl: string, params: FreeTable$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>> {
  const rb = new RequestBuilder(rootUrl, freeTable.PATH, 'put');
  if (params) {
    rb.path('tableId', params.tableId, {});
    rb.query('venueId', params.venueId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>;
    })
  );
}

freeTable.PATH = '/api/groups/layouts/tables/{tableId}';
